// lib/turnierArt.js — Art des Turniers (22.10.2026)
// Abschrift der Werteliste aus backend/utils/turnierArt.js (ENUM turniere.art).
// Der Server prüft selbst; hier steht nur, was die Auswahl anbietet.
export const TURNIER_ARTEN = ['Turnier', 'Meisterschaft', 'Ranglistenturnier', 'Lehrgang', 'Sonstiges'];
export const STANDARD_ART = 'Turnier';
